function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("polygon", {
  id: "badges-a",
  points: "0 .001 20 .001 20 20 0 20"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
},
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M9.0364,13.3777 L8.2574,12.6707 L6.2934,10.7067 C5.9024,10.3157 5.9024,9.6837 6.2934,9.2927 C6.6834,8.9017 7.3164,8.9017 7.7074,9.2927 L9.0004,10.5857 L12.2934,7.2927 C12.6834,6.9017 13.3164,6.9017 13.7074,7.2927 C14.0984,7.6837 14.0984,8.3157 13.7074,8.7067 L9.0364,13.3777 Z"
}),
/*#__PURE__*/
React.createElement("mask", {
  id: "badges-b",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#badges-a"
})),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M7.5144,16.2754 C7.7184,16.2754 7.9174,16.3374 8.0844,16.4534 L10.0004,17.7824 L11.9154,16.4534 C12.0834,16.3374 12.2814,16.2754 12.4854,16.2754 L12.4874,16.2754 L14.8474,16.2794 L15.5604,14.1754 C15.6304,13.9714 15.7644,13.7954 15.9404,13.6724 L17.8074,12.3884 L17.0984,10.3254 C17.0254,10.1144 17.0254,9.8854 17.0984,9.6744 L17.8074,7.6114 L15.9404,6.3274 C15.7644,6.2054 15.6304,6.0284 15.5604,5.8244 L14.8474,3.7204 L12.4874,3.7244 L12.4854,3.7244 C12.2814,3.7244 12.0834,3.6624 11.9154,3.5464 L10.0004,2.2174 L8.0844,3.5464 C7.9174,3.6624 7.7184,3.7244 7.5144,3.7244 L7.5124,3.7244 L5.1544,3.7204 L4.4394,5.8244 C4.3704,6.0284 4.2374,6.2054 4.0594,6.3274 L2.1934,7.6114 L2.9024,9.6744 C2.9744,9.8854 2.9744,10.1144 2.9024,10.3254 L2.1934,12.3884 L4.0594,13.6724 C4.2374,13.7954 4.3704,13.9714 4.4394,14.1754 L5.1544,16.2794 L7.5124,16.2754 L7.5144,16.2754 Z M10.0004,20.0004 C9.8014,20.0004 9.6014,19.9404 9.4304,19.8214 L7.2024,18.2754 L4.4394,18.2814 L4.4374,18.2814 C4.0094,18.2814 3.6284,18.0084 3.4914,17.6024 L2.6524,15.1324 L0.4334,13.6054 C0.0634,13.3504 -0.0916,12.8804 0.0544,12.4564 L0.8994,10.0004 L0.0544,7.5444 C-0.0916,7.1194 0.0634,6.6494 0.4334,6.3954 L2.6524,4.8674 L3.4914,2.3974 C3.6284,1.9914 4.0094,1.7184 4.4374,1.7184 L4.4394,1.7184 L7.2024,1.7244 L9.4304,0.1784 C9.7734,-0.0586 10.2264,-0.0586 10.5704,0.1784 L12.7984,1.7244 L15.5604,1.7184 L15.5624,1.7184 C15.9914,1.7184 16.3724,1.9914 16.5104,2.3974 L17.3474,4.8674 L19.5674,6.3954 C19.9364,6.6494 20.0924,7.1194 19.9454,7.5444 L19.1014,10.0004 L19.9454,12.4564 C20.0924,12.8804 19.9364,13.3504 19.5674,13.6054 L17.3474,15.1324 L16.5104,17.6024 C16.3724,18.0094 15.9784,18.2824 15.5604,18.2814 L12.7984,18.2754 L10.5704,19.8214 C10.3994,19.9404 10.1994,20.0004 10.0004,20.0004 L10.0004,20.0004 Z",
  mask: "url(#badges-b)"
}));

var SvgBadges = function SvgBadges(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref, _ref2)
  );
};

export default SvgBadges;